import HotTub from '@material-ui/icons/HotTub'
import { Button, styled } from 'opensolar-ui'
import { useAuthenticated, useTranslate } from 'ra-core'

const Container = styled('div', { name: 'container' })(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    height: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    height: '100vh',
    marginTop: '-3em',
  },
}))

const Icon = styled(HotTub, { name: 'hotTub' })({
  width: '9em',
  height: '9em',
})

const Message = styled('div', { name: 'message' })({
  textAlign: 'center',
  fontFamily: 'Roboto, sans-serif',
  opacity: 0.5,
  margin: '0 1em',
})

const Toolbar = styled('div', { name: 'toolbar' })({
  textAlign: 'center',
  marginTop: '2em',
})

function goBack() {
  window.history.go(-1)
}

interface Props {
  staticContext?: any
  location?: any
  match?: any
}

const NotFound = (props: Props) => {
  const translate = useTranslate()
  useAuthenticated()

  const { staticContext, location, match, ...rest } = props

  return (
    <Container {...rest}>
      <Message>
        <Icon />
        <h1>{translate('ra.page.not_found')}</h1>
        <div>{translate('ra.message.not_found')}.</div>
      </Message>
      <Toolbar>
        <Button variant="contained" onClick={goBack}>
          <span>{translate('ra.action.back')}</span>
        </Button>
      </Toolbar>
    </Container>
  )
}

export default NotFound
